import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.find";
import "core-js/modules/es.array.find-index";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.splice";
import _toConsumableArray from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getReturnData, addtecLinks, updatatecLinks } from "@/api/dataAll/links";
import { Message } from "element-ui";
import { getadvLocation } from "@/api/dataAll/advLocation";
import { allChannel } from "@/api/aymentsdk/getchancllist";
import { serchSelect, serchSelectManage } from "@/mixins/index";
import { productDetails } from "@/api/management/productMapping";
export default {
  name: "addLinks",
  mixins: [serchSelect, serchSelectManage],
  data: function data() {
    return {
      dialogFormVisible: false,
      searchData: {
        game: "",
        platform: "",
        channel: "",
        pkg: "",
        special_product_id: "",
        expand_parameter: {},
        op_ad_channel: 'jl'
      },
      opAdChannel: [{
        label: this.$t('adPlatformJuliang'),
        value: 'jl'
      }, {
        label: this.$t('adPlatformGuangdiantong'),
        value: 'gdt'
      }],
      ex_Val: [],
      ex_ValAdv: [],
      rules: {
        game: [{
          required: true,
          message: this.$t('game'),
          trigger: "blur"
        }],
        platform: [{
          required: true,
          message: this.$t('platform'),
          trigger: "blur"
        }],
        channel: [{
          required: true,
          message: this.$t('channel'),
          trigger: "blur"
        }],
        pkg: [{
          required: true,
          message: this.$t('pkg'),
          trigger: "blur"
        }],
        op_ad_channel: [{
          required: true,
          message: this.$t('pleaseSelect'),
          trigger: "blur"
        }]
      }
    };
  },
  created: function created() {},
  methods: {
    init: function init(row) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _yield$getReturnData, data;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.dialogFormVisible = true;

                if (!row) {
                  _context.next = 16;
                  break;
                }

                _context.next = 4;
                return getReturnData({
                  id: row.id
                });

              case 4:
                _yield$getReturnData = _context.sent;
                data = _yield$getReturnData.data;
                _context.next = 8;
                return _this.getAdvPlarform({
                  special_product_id: row.product_id
                });

              case 8:
                _this.searchData = _this.processingData(_objectSpread(_objectSpread(_objectSpread({}, _this.searchData), data), {}, {
                  special_product_id: row.product_id
                }));

                _this.ex_Val.push({
                  ad_channel: _this.searchData.ad_channel,
                  ad_placement: _this.searchData.ad_placement
                });

                _this.ex_ValAdv.push({
                  advchannels: _this.advchannels,
                  advLocation: []
                });

                _context.next = 13;
                return _this.advChannelchange(_this.searchData.ad_channel, 0);

              case 13:
                _this.ex_Val[0].ad_placement = _this.searchData.ad_placement;
                _context.next = 17;
                break;

              case 16:
                _this.searchData = {
                  game: "",
                  platform: "",
                  channel: "",
                  pkg: "",
                  special_product_id: "",
                  expand_parameter: {},
                  op_ad_channel: 'jl'
                };

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    resetForm: function resetForm(formName) {
      this.dialogFormVisible = false;
      this.searchData.id = '';
      this.clearData();
    },
    removeDomain: function removeDomain(item) {
      var index = this.ex_Val.indexOf(item);

      if (index !== -1) {
        this.ex_Val.splice(index, 1);
        this.ex_ValAdv.splice(index, 1);
      }
    },
    addDomain: function addDomain() {
      if (!this.searchData.special_product_id) {
        Message.success(this.$t('pleaseSelectProductFirst'));
        return;
      }

      this.ex_Val.push({
        ad_channel: "",
        ad_placement: ""
      });
      this.ex_ValAdv.push({
        advchannels: this.advchannels,
        advLocation: []
      });
    },
    advChannelchange: function advChannelchange(adv_platform_mark, index) {
      this.ex_Val[index].ad_placement = '';
      this.ex_ValAdv[index].advLocation = [];

      if (adv_platform_mark != "") {
        this.ex_ValAdv[index].advLocation = this.ex_ValAdv[index].advchannels.find(function (i) {
          return i.adv_platform_mark == adv_platform_mark;
        }).adv_place_data ? this.ex_ValAdv[index].advchannels.find(function (i) {
          return i.adv_platform_mark == adv_platform_mark;
        }).adv_place_data : [];
        var listDf = this.ex_Val[index].ad_channel == 'default' && this.ex_ValAdv[index].advLocation.findIndex(function (j) {
          return j.adv_place_mark == 'default';
        }) == -1 ? [{
          adv_place_mark: "default",
          adv_place_name: this.$t('defaultLabel')
        }] : [];
        this.ex_ValAdv[index].advLocation.map(function (i) {
          i.adv_place_mark = i.adv_place_mark ? i.adv_place_mark : "valuets";
        });
        this.ex_ValAdv[index].advLocation = [].concat(listDf, _toConsumableArray(this.ex_ValAdv[index].advLocation));
      }
    },
    dataFormSubmit: function dataFormSubmit(formName) {
      var _this2 = this;

      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          var ex_ValList = JSON.parse(JSON.stringify(_this2.ex_Val));
          ex_ValList.map(function (i) {
            if (i.ad_placement) {
              i.ad_placement = i.ad_placement == 'valuets' ? '' : i.ad_placement;
            } else {
              delete i.ad_placement;
            }
          });
          _this2.searchData.expand_parameter = JSON.stringify(ex_ValList);
          _this2.searchData.kind = 1;
          var req = _this2.searchData.id ? updatatecLinks : addtecLinks;
          req(_this2.searchData).then(function (res) {
            if (res.status == 200) {
              Message.success(_this2.$t('operationSuccess'));

              if (_this2.searchData.game_id) {
                _this2.$emit("refreshDataList");
              }

              _this2.resetForm();
            }
          });
        }
      });
    },
    clearData: function clearData() {
      this.searchData = {
        id: this.searchData.id,
        game: "",
        platform: "",
        channel: "",
        pkg: "",
        expand_parameter: {},
        op_ad_channel: 'jl'
      };
      this.searchplatforms = [];
      this.searchchannels = [];
      this.searchpkgs = [];
      this.ex_Val = [];
      this.ex_ValAdv = [];
      this.$refs.ruleForm.resetFields();
    }
  }
};